module.exports = __webpack_public_path__ + "img/openstack.638b1003.svg";